import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from '../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {Order} from "../../../models/order";


@Component({
    selector: 'confirm-bill-print-dialog',
    templateUrl: './confirmBillPrintDialog.component.html',
    styleUrls: ['./confirmBillPrintDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class ConfirmBillPrintDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    isInvoice: boolean = false;
    order: Order;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<ConfirmBillPrintDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.order = _data.order;
        this.isInvoice = _data.isInvoice;
        this.translationLoader.loadTranslations(polish);
    }
}
